{
  "version": 1,
  "asset_id": "21c68bec-dfd1-45c6-8a77-48ecb90138ac",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/21c68bec-dfd1-45c6-8a77-48ecb90138ac/bypass-revision-downsizing-en-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/21c68bec-dfd1-45c6-8a77-48ecb90138ac/bypass-revision-downsizing-en-640.webp",
  "original_filename": "bypass-revision-downsizing-en-640.webp",
  "size": 41678,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:45Z"
}
